export default __webpack_public_path__ + "static/house-demolition-icon-523a4ebcb4ecdf692b38fc53060b3784.png";